var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-listed"},[_c('div',{staticClass:"not-listed__text"},[_vm._t("default")],2),_c('div',{staticClass:"not-listed__action"},[_vm._t("action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }